export const SIDEBAR_ROOT_ID = 'sidebar-root-id'
export const SIDEBAR_CONTENT_ID = 'sidebar-content-id'
export const SIDEBAR_BOTTOM_CONTENT_ID = 'sidebar-bottom-content-id'

export const PAGE_UI_ID = 'page-ui'
export const WORK_AREA_ID = 'work-area'

export const POPUP_CONTENT_ID = 'popup-scroll-content-ui'
